import { isCancellationPolicyApplicable } from '@shared/reservations/reservationUtil';
import { centsToDollar } from '@shared/utils/currency';
import { toShortDateTime } from '@shared/utils/dateFormatters';
import cx from 'classnames';
import { parseISO, subHours } from 'date-fns';
import typography from '~styles/typography.scss';
import styles from './CancellationPolicyNotice.scss';

export interface CancellationPolicyNoticeProps {
  purchasePrice: number;
  threshold: number;
  availabilityTime: string;
  hoursBeforeReservation: number;
  date: string;
  cancellationFee: number;
}

export const CancellationPolicyNotice = ({
  availabilityTime,
  cancellationFee,
  date,
  hoursBeforeReservation,
  purchasePrice,
  threshold,
}: CancellationPolicyNoticeProps) => {
  const timeBeforeCancellationApplies = subHours(
    parseISO(`${date}T${availabilityTime}`),
    hoursBeforeReservation,
  );
  const wasTablePurchased = purchasePrice > 0;

  return (
    <div className={styles.container}>
      <h3 className={typography.h6}>Cancellation Policy</h3>
      {wasTablePurchased && (
        <p className={cx(typography.t2, styles.text)}>
          <strong>Your table purchase is non-refundable.</strong>
        </p>
      )}
      {isCancellationPolicyApplicable(purchasePrice, threshold) && (
        <p className={cx(typography.t2, styles.text)}>
          You may cancel your reservation before{' '}
          {toShortDateTime(timeBeforeCancellationApplies)} (local to the
          restaurant). After that, cancelling this reservation may trigger an
          additional fee of {centsToDollar(cancellationFee)}
        </p>
      )}
    </div>
  );
};
